import { render, staticRenderFns } from "./CDOrganizationsSection.vue?vue&type=template&id=00815006&scoped=true"
import script from "./CDOrganizationsSection.vue?vue&type=script&lang=ts"
export * from "./CDOrganizationsSection.vue?vue&type=script&lang=ts"
import style0 from "./CDOrganizationsSection.vue?vue&type=style&index=0&id=00815006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00815006",
  null
  
)

export default component.exports